import {
  callGet,
  callPost,
  callPutById,
  callDelete,
} from "../integrations/calls";

import { REQ } from "../../libs/constants";

export const getAllVehical = async (token) => {
  return await callGet(`${REQ.VEHICAL.GET_ALL_VEHICAL}`, token);
};

export const createSpecialRate = async (data, token) => {
  return await callPost(REQ.SPECIAL_RATE.SAVE_DATA, data, token);
};

export const getRate = async (data, token) => {
    return await callPost(REQ.SPECIAL_RATE.GET_RATE, data, token);
  };

export const updateSpecialRate = async (data, token) => {
  return await callPutById(
    `${REQ.SPECIAL_RATE.UPDATE_RATE}/${data.partyId}/${data.itemCode}`,
    data,
    token
  );
};

export const deleteSingleVehical = async (data, token) => {
  return await callDelete(
    `${REQ.VEHICAL.DELETE_VEHICAL}/${data.id}`,
    data,
    token
  );
};
